var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drawer-box"},[_c('LmobileNav'),_vm._v(" "),_c('Nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }